module.exports = __webpack_public_path__ + "img/finance-off.93021963.svg";